import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAM_BY_ID = gql`
  query SubsidyCalculatorGetFinanceProgramById($financeProgramId: ID!) {
    financeProgram(id: $financeProgramId) {
      financeProgramId
      nameInternal
      paymentOptionsConfiguration
    }
  }
`;
